// @flow

import type { PlanTier } from '@zapier/common-utils';

export default (tier: PlanTier): boolean => tier.pricePerTask === 0;
